/* eslint-disable @typescript-eslint/no-unused-vars */
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import SettingsProfile from '../pages/settings/profile'
import SettingUsers from '../pages/settings/users'
import SettingsSecurity from '../pages/settings/security'
import SettingsPermission from '../pages/settings/permission'
import ContactUserDetails from '../pages/contacts/contactDetails'
import LeadsMain from '../pages/contacts/LeadsMain'
import CustomerMain from '../pages/contacts/CustomerMain'
import CompanyMain from '../pages/contacts/CompanyMain'
import MixedLeadsMain from '../pages/contacts/mixedMain'
import SuperAdminLeadStatus from '../pages/lead-status/SuperAdminLeadStatus'
import SuperAdminPermission from '../pages/permission/SuperAdminPermission'
import Package from '../pages/package/package'
import UserDetails from '../pages/settings/userDetails'
import MarketingDashboard from '../pages/marketing/marketingDashboard'
import AddCampaign from '../pages/marketing/AddCampaign'
import CampaignList from '../pages/marketing/CampaignList'
import CampaignDetails from '../pages/marketing/CampaignDetails'
import SelectRecipients from '../pages/marketing/SelectRecipients'
import ConfirmationCampaignPeriod from '../pages/marketing/ConfirmationCampaignPeriod'
import CustomizedDate from '../pages/marketing/CustomizedDate'
import CampaignConfirmation from '../pages/marketing/CampaignConfirmation'
import CampaignAddSuccessful from '../pages/marketing/CampaignAddSuccessful'
import PackageSubscription from '../pages/settings/package-subscription'
import PaymentHistory from '../pages/settings/payment-history'
import ApprovedRequests from '../pages/sms-requests/ApprovedRequests'
import PendingRequests from '../pages/sms-requests/PendingRequests'
import EditCampaign from '../pages/marketing/EditCampaign'
import EditSelectRecipients from '../pages/marketing/EditSelectRecipients'
import EditConfirmationCampaignPeriod from '../pages/marketing/EditConfirmationCampaignPeriod'
import EditCampaignConfirmation from '../pages/marketing/EditCampaignConfirmation'
import EditCampaignAddSuccessful from '../pages/marketing/EditCampaignAddSuccessful'
import EditCustomizedDate from '../pages/marketing/EditCustomizedDate'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='contact/customers' element={<CustomerMain />} />
        <Route path='contact/details/:id' element={<ContactUserDetails />} />
        <Route path='contact/new-leads' element={<LeadsMain />} />
        <Route path='campaign-dashboard' element={<MarketingDashboard />} />
        <Route path='campaign-list' element={<CampaignList />} />
        <Route path='campaign/details/:id' element={<CampaignDetails />} />
        <Route path='add-campaign' element={<AddCampaign />} />
        <Route path='campaign/select-recipients' element={<SelectRecipients/>} />
        <Route path='campaign/confirmation-campaign-period' element={<ConfirmationCampaignPeriod/>} />
        <Route path='campaign/customized-date' element={<CustomizedDate/>} />
        <Route path='campaign/confirmation' element={<CampaignConfirmation/>} />
        <Route path='campaign/add-successful' element={<CampaignAddSuccessful/>} />
        <Route path='edit-campaign/:id' element={<EditCampaign/>} />
        <Route path='campaign/edit-select-recipients' element={<EditSelectRecipients/>} />
        <Route path='campaign/edit-confirmation-campaign-period' element={<EditConfirmationCampaignPeriod/>} />
        <Route path='campaign/edit-customized-date' element={<EditCustomizedDate/>} />
        <Route path='campaign/edit-confirmation' element={<EditCampaignConfirmation/>} />
        <Route path='campaign/edit-add-successful' element={<EditCampaignAddSuccessful/>} />
        <Route path='contact/companies' element={<CompanyMain />} />
        <Route path='contact/mixed' element={<MixedLeadsMain />} />
        <Route path='settings/profile' element={<SettingsProfile />} />
        <Route path='settings/users' element={<SettingUsers />} />
        <Route path='settings/user/details/:id' element={<UserDetails />} />
        <Route path='settings/package-subscription' element={<PackageSubscription />} />
        <Route path='settings/payment-history' element={<PaymentHistory />} />
        <Route path='settings/security' element={<SettingsSecurity />} />
        <Route path='settings/permissions' element={<SettingsPermission />} />
        <Route path='lead-status' element={<SuperAdminLeadStatus />} />
        <Route path='permission' element={<SuperAdminPermission />} />
        <Route path='package' element={<Package />} />
        <Route path='approved-requests' element={<ApprovedRequests />} />
        <Route path='pending-requests' element={<PendingRequests />} />

        {/* Lazy Modules */}
        {/* <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
